import AboutSection from "./components/AboutSection";
import Divider from "./components/Divider";
import Footer from "./components/Footer";
import Header from "./components/Header";
import LandingSection from "./components/LandingSection";
import ServicesSection from "./components/ServicesSection";
import React from "react";

export default function App() {
  return (
    <>
      <Header />
      <LandingSection />
      <AboutSection />
      <Divider />
      <ServicesSection />
      <Footer />
    </>
  );
}
